import React, { useState } from "react";
import {
  LayoutDashboard, BarChart3, Search, Megaphone, Inbox, Sparkles, Plug,
} from "lucide-react";
import OverviewTab from "./OverviewTab";
import IntegrationsTab from "./IntegrationsTab";
import WebsiteAnalyticsTab from "./WebsiteAnalyticsTab";
import GoogleAdsTab from "./GoogleAdsTab";
import SearchConsoleManager from "../SearchConsoleManager";
import SeoAiVisibilityTab from "./SeoAiVisibilityTab";
import TrackingSetupPanel from "../TrackingSetupPanel";
import AnalyticsManager from "../AnalyticsManager";
import DashboardSummary from "../DashboardSummary";
import LeadSourceReport from "../LeadSourceReport";

const TABS = [
  { key: "overview", label: "Overview", icon: LayoutDashboard },
  { key: "analytics", label: "Website Analytics", icon: BarChart3 },
  { key: "search", label: "Google Search", icon: Search },
  { key: "ads", label: "Google Ads", icon: Megaphone },
  { key: "leads", label: "Leads & Conversions", icon: Inbox },
  { key: "visibility", label: "SEO & AI Visibility", icon: Sparkles },
  { key: "integrations", label: "Tracking & Integrations", icon: Plug },
];

export default function GooglePerformance() {
  const [tab, setTab] = useState(() => localStorage.getItem("google-perf-tab") || "overview");

  const open = (key) => {
    setTab(key);
    localStorage.setItem("google-perf-tab", key);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="space-y-6" data-testid="google-performance">
      <div className="flex gap-1.5 overflow-x-auto pb-1 -mx-1 px-1">
        {TABS.map((t) => {
          const Icon = t.icon;
          const on = tab === t.key;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => open(t.key)}
              data-testid={`google-tab-${t.key}`}
              className={`inline-flex items-center gap-2 px-3.5 py-2 rounded-lg text-xs font-bold whitespace-nowrap duration-200 [transition-property:background-color,color] ${
                on ? "bg-navy text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"
              }`}
            >
              <Icon size={14} /> {t.label}
            </button>
          );
        })}
      </div>

      {tab === "overview" && <OverviewTab onOpenTab={open} />}
      {tab === "analytics" && <WebsiteAnalyticsTab />}
      {tab === "search" && <SearchConsoleManager />}
      {tab === "ads" && <GoogleAdsTab />}
      {tab === "leads" && (
        <div className="space-y-6" data-testid="google-leads-tab">
          <DashboardSummary />
          <AnalyticsManager />
          <LeadSourceReport />
        </div>
      )}
      {tab === "visibility" && (
        <div data-testid="google-visibility-tab">
          <SeoAiVisibilityTab />
        </div>
      )}
      {tab === "integrations" && (
        <div className="space-y-6" data-testid="google-integrations-tab">
          <IntegrationsTab />
          <TrackingSetupPanel />
        </div>
      )}
    </div>
  );
}
